<template>
    <div>
        <h3>พิมพ์รายงานการผลิตชีท</h3>
        <br />
        <div class="row">
            <b-col class="col-sm-4">กรุณาเลือกกะที่ต้องการพิมพ์รายงาน</b-col>
            <b-col class="col-sm-6"><input type="text"/></b-col>
        </div>
        <br/>
        <div class="row">
            <b-col class="col-sm-4">กรุณาเลือกวันที่ที่ต้องการพิมพ์รายงาน</b-col>
            <b-col class="col-sm-6"><input type="text"/></b-col>
        </div>
        <b-row>
            <div class="col text-center">
                <button type="button" class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon> บันทึก
                </button>&nbsp&nbsp
                <button type="button" class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "print-sheet-report-modal"
    }
</script>

<style scoped>

</style>